import React from 'react'
import ExternalLink from 'shared-components/ExternalLink'

const instructions = (
  <div>
    <div className="margin-bottom-2">
      <div className="grid-fluid-colmin-22em margin-bottom-1">
        <div className="panel--simple md-padded-2">
          <h3 className="flex-row-center">
            <span className="list-number margin-right-1ch">1</span> BZRX Compensation
          </h3>
          <h4>Who is entitled to BZRX compensation?</h4>
          <ul className="list-spaced-2 txt-explanation">
            <li>Users who lent BZRX to the protocol.</li>
            <li>Users who used BZRX as collateral in loans.</li>
            <li>Users who have PGOV/BGOV not yet converted.</li>
            <li>Users who had GOV LP tokens held in farming.</li>
            <li>Users who had GOV LP tokens in their wallet.</li>
            <li>Users that lost BZRX due infinite approval.</li>
          </ul>
        </div>
        <div className="panel--simple md-padded-2">
          <h3 className="flex-row-center">
            <span className="list-number margin-right-1ch">2</span> Debt Token P125
          </h3>
          <h4>What is the P125 token?</h4>
          <ul className="list-spaced-2  txt-explanation">
            <li>
              <b>P125</b> is a debt token that the protocol repays over time.
            </li>
            <li>The token has a 25% premium.</li>
            <li>
              The premium means that if you lost an equivalent of 100 USD at the moment of the
              incident, you have the possibility to get back 125 USD over time.
            </li>
          </ul>
          <h4>Who is entitled to P125 compensation?</h4>
          <ul className="txt-explanation">
            <li>Users who lost tokens other than BZRX.</li>
          </ul>
        </div>
      </div>
      <p className="txt-center">
        <ExternalLink
          className="link--discreet"
          href="https://snapshot.org/#/bzx.eth/proposal/0x1c09762c97dcd04287cafde35b23d5421f88054b636245e4a0f909843990eea4">
          Read the compensation snapshot proposal for detailed information.
        </ExternalLink>
      </p>
    </div>
  </div>
)

export default function CompensationDetails() {
  return instructions
}
